import IncomingOrderSound from '../assets/sound/IncomingOrderSound.wav';
import DispatchSoundFile from '../assets/sound/dispatch.mp3';
import PastOrdersSoundFile from '../assets/sound/past_order.mp3';
import RiderRejectSoundFile from '../assets/sound/rider_reject.wav';
import { getLiveOrders } from '../api/liveOrders/getLiveOrderNewAPI';
import { getLiveOrderDetailsAPI } from '../api/liveOrders/getLiveOrderDetailsAPI';
import { appendOrderFromNotification } from '../api/liveOrders/appendOrderFromNotification';
import { updateOrderFromNotification } from '../api/liveOrders/updateOrderFromNotification';
import { removeCompletedOrder } from '../api/liveOrders/removeCompletedOrder';
import { getPastOrdersForNotification } from '../api/pastOrder/getPastOrdersForNotification';
import { getFailedOrdersForNotification } from '../api/failedOrders/getFailedOrdersForNotification';
import store from '../reduxStore/index';
import { updateCreditAlerts } from '../api/CreditAlert/fetchAlerts';
import moment from 'moment';
import { fetchCreditTransactions } from '../api/topup/TransactionHistory';
import { fetchOutletSections } from '../components/TableManagement/Api/fetchOutletSections';
import { fetchTableOrderDetails } from '../components/TableManagement/Api/tableOperations';
import { fetchOutletOrderingModes } from '../api/outlet/fetchOutletOrderingModes';
import { fetchRestaurantOrderingModes } from '../components/settings/RestaurantSettings/Utils/utils';

export const playNotificationSound = (status) => {
    let soundFile = null;

    if (status === 'rider_picked_up') {
        soundFile = DispatchSoundFile;
    } else if (status === 'rider_delivered' || status === 'customer_picked_up') {
        soundFile = PastOrdersSoundFile;
    } else if (status === 'rider_reject') {
        soundFile = RiderRejectSoundFile;
    } else if (status === 'placed') {
        soundFile = IncomingOrderSound;
    }

    if (soundFile) {
        let sound = new Audio(soundFile);
        sound.play();
    }
};

export const serviceWorkerEventListner = (payload) => {
    const startDate = moment();
    const endDate = moment();
    const pagination = {
        pageIndex: 0,
        pageSize: 10,
    };
    return async (dispatch) => {
        // Support both new FCM format (payload.data.data) and legacy format (payload.data['firebase-messaging-msg-data'].data)
        const msgData = payload.data && (payload.data.data || (payload.data['firebase-messaging-msg-data'] && payload.data['firebase-messaging-msg-data'].data));
        if (!msgData || !msgData.param) {
            return;
        }

        let notificationPayload = JSON.parse(msgData.param);

        if (window.location.pathname == '/past-orders' && notificationPayload.status === 'order_refunded') {
            dispatch(getPastOrdersForNotification());
        }

        // console.log("failed orders service ", notificationPayload)
        if (window.location.pathname === '/failed-orders' && notificationPayload.status === 'order_refunded') {
            dispatch(getFailedOrdersForNotification());
        }

        // if (
        //     window.location.pathname !== '/live-orders' &&
        //     (notificationPayload.status === 'placed' || notificationPayload.status === 'restaurant_accepted')
        // ) {
        //     dispatch(getNewOrdersCount());
        // }

        if (
            window.location.pathname === '/table-management' &&
            (notificationPayload.status === 'placed' ||
                notificationPayload.status === 'restaurant_accepted' ||
                notificationPayload.status === 'restaurant_ready' ||
                notificationPayload.status === 'delivered' ||
                notificationPayload.status === 'restaurant_cancelled' ||
                notificationPayload.status === 'table_settled')
        ) {
            dispatch(fetchOutletSections());
        }

        if (
            (window.location.pathname === '/table-management' && notificationPayload.status === 'placed') ||
            notificationPayload.status === 'table_settled' ||
            notificationPayload.status === 'delivered' ||
            notificationPayload.status === 'payment_processed'
        ) {
            dispatch(fetchTableOrderDetails());
        }

        if (window.location.pathname === '/outlet-settings' && notificationPayload.status === 'outlet_menu_updated') {
            dispatch(fetchOutletOrderingModes());
            dispatch(fetchRestaurantOrderingModes());
        }

        if (
            notificationPayload.status === 'razorpay_order_paid' ||
            notificationPayload.status === 'outlet_settings_updated'
        ) {
            dispatch(updateCreditAlerts());
            dispatch({
                type: 'update_date_time',
                payload: {
                    startDate: startDate,
                    endDate: endDate,
                },
            });
        }

        if (notificationPayload.status === 'infrastructure_credit') {
            dispatch(fetchCreditTransactions(pagination, 'infrastructure', startDate, endDate)).then((res) => {
                if (res.success) {
                    dispatch({
                        type: 'update_transaction_list',
                        payload: res,
                    });
                }
            });
        }
        if (notificationPayload.status === 'service_credit') {
            dispatch(fetchCreditTransactions(pagination, 'services', startDate, endDate)).then((res) => {
                if (res.success) {
                    dispatch({
                        type: 'update_transaction_list',
                        payload: res,
                    });
                }
            });
        }
        if (window.location.pathname === '/live-orders') {
            // Get current restaurant and outlet from Redux state
            const state = store.getState();
            const currentRestaurantId = state.auth.selectedRestaurantId;
            const currentOutletId = state.outlet.selectedOutletId;

            // Check if notification is for the current restaurant/outlet
            // If we have order_details, check if it matches current selection
            if (notificationPayload.order_details) {
                const notificationRestaurantId = notificationPayload.order_details.restaurant_id;
                const notificationOutletId = notificationPayload.order_details.outlet_id;

                // Skip notification if it's for a different restaurant or outlet
                if (
                    currentRestaurantId &&
                    notificationRestaurantId &&
                    parseInt(currentRestaurantId) !== parseInt(notificationRestaurantId)
                ) {
                    return;
                }

                if (
                    currentOutletId &&
                    notificationOutletId &&
                    parseInt(currentOutletId) !== parseInt(notificationOutletId)
                ) {
                    return;
                }
            }

            // Check if this is a new order and we have order_details in the payload
            if (notificationPayload.status === 'placed' && notificationPayload.order_details) {
                // Always append new order directly without calling API
                // This works regardless of pagination or current order count
                dispatch(appendOrderFromNotification(notificationPayload.order_details));

                // The reducer will handle selection and prevent duplicates
            } else if (notificationPayload.order_details && notificationPayload.order_details.order_id) {
                // For order updates (not new orders), update the order in the state
                const state = store.getState();

                const existingOrder = state.orders.liveOrders.find(
                    (order) => order.order_id === notificationPayload.order_details.order_id
                );

                if (existingOrder) {
                    // Check if the order is being completed
                    const completedStatuses = [
                        'customer_picked_up',
                        'delivered',
                        'rider_delivered',
                        'restaurant_cancelled',
                    ];

                    if (completedStatuses.includes(notificationPayload.order_details.delivery_status)) {
                        // Remove completed order from state
                        dispatch(removeCompletedOrder(notificationPayload.order_details.order_id));
                    } else {
                        // DEDUP: Skip if API already synced this order recently (prevents double re-render)
                        const lastSync = state.orders._lastApiSyncAt?.[notificationPayload.order_details.order_id];
                        const isRecentlySynced = lastSync && (Date.now() - lastSync) < 3000;
                        if (!isRecentlySynced) {
                            // Update the existing order with new data from notification
                            dispatch(updateOrderFromNotification(notificationPayload.order_details));
                        }
                    }

                    // No need to call getLiveOrderDetailsAPI() as the reducer already updates selectedOrderDetails
                } else {
                    // Check if this is a completed order notification
                    const completedStatuses = [
                        'customer_picked_up',
                        'delivered',
                        'rider_delivered',
                        'restaurant_cancelled',
                    ];
                    if (completedStatuses.includes(notificationPayload.order_details.delivery_status)) {
                        // Don't fetch the list for completed orders that aren't in our current view
                        return;
                    }

                    // Order not found in current list, might be on different page or filter
                    // In this case, we still need to fetch the list
                    dispatch(getLiveOrders());
                    dispatch(getLiveOrderDetailsAPI());
                }
            } else if (notificationPayload.order_id && !notificationPayload.order_details) {
                // Handle case where order_details is null but we have order_id (completed orders)
                const completedStatuses = [
                    'customer_picked_up',
                    'delivered',
                    'rider_delivered',
                    'restaurant_cancelled',
                ];

                if (completedStatuses.includes(notificationPayload.status)) {
                    // This is a completed order notification
                    const existingOrder = state.orders.liveOrders.find(
                        (order) => order.order_id === notificationPayload.order_id
                    );

                    if (existingOrder) {
                        // Check if this order belongs to the current restaurant/outlet
                        if (
                            currentRestaurantId &&
                            existingOrder.restaurant_id &&
                            parseInt(currentRestaurantId) !== parseInt(existingOrder.restaurant_id)
                        ) {
                            return;
                        }

                        if (
                            currentOutletId &&
                            existingOrder.outlet_id &&
                            parseInt(currentOutletId) !== parseInt(existingOrder.outlet_id)
                        ) {
                            return;
                        }

                        dispatch(removeCompletedOrder(notificationPayload.order_id));
                    }
                } else {
                    // Non-completed status without order details
                    // Check if we have this order in our current state
                    const existingOrder = state.orders.liveOrders.find(
                        (order) => order.order_id === notificationPayload.order_id
                    );

                    if (existingOrder) {
                        // If we have the order, it means it's for our restaurant/outlet
                        // Don't fetch the list, the notification with order_details will come
                        return;
                    }

                    // If we don't have the order, it might be for a different restaurant/outlet
                    // Don't fetch the list as it's not relevant to us
                }
            } else {
                // For other notifications without order details
                // Don't refresh the list as we can't determine if it's for our restaurant
                // This prevents unnecessary API calls when notifications from other restaurants arrive
            }
        }

        if (notificationPayload.display_notification) {
            var options = {
                body: msgData.body,
                requireInteraction: true,
                icon: msgData.icon,
                click_action: msgData.click_action,
            };

            if (!notificationPayload.persistent) {
                options.requireInteraction = false;
            }

            if (Notification.permission === 'granted') {
                new Notification(msgData.title, options);
            }
        }

        if (notificationPayload.sound) {
            playNotificationSound(notificationPayload.status);
        }
    };
};
